import Button, { iButtonDisplayOptions } from 'fulogics-ui-web/dist/layout/dx/Button/Button';
import { iDataGridDisplayOptions } from 'fulogics-ui-web/dist/layout/dx/DataGrid/DataGrid';
import { iFormDisplayOptions } from 'fulogics-ui-web/dist/layout/dx/Form/Form';
import { iSelectBoxDisplayOptions } from 'fulogics-ui-web/dist/layout/dx/SelectBox/SelectBox';
import propsStore from 'fulogics-ui-web/dist/layout/inspector/propsStore';
import { iNumberBoxDisplayOptions } from 'fulogics-ui-web/dist/layout/dx/NumberBox';
import { nameof } from 'ts-simple-nameof';
import {
    PayloadAddFormPayloadData,
    ProductCarrierItemData,
    ProductToAddInfoFormData,
    ProductToAddSelectBoxInfoData,
} from './PayloadAddForm';
import { RouteLocationModelSimpleTextDisplayOptions } from 'fulogics-ui-web/dist/layout/components/route-location-model-simple-text/RouteLocationModelSimpleText';
import { LogisticUnitSimpleTextData } from 'fulogics-ui-web/dist/layout/components/logistic-unit-simple-text/LogisticUnitSimpleText';
import { iLookupDisplayOptions } from 'fulogics-ui-web/dist/layout/dx/Lookup';
import { iLayoutControlDisplayOptions } from 'fulogics-ui-web/dist/layout/layout-control/LayoutControl';
import { FlexTemplateProps } from 'fulogics-ui-web';
import { AllowedStacksHeaderProps } from '../../templates/dataGrid/header/allowed-stacks-header-template/AllowedStacksHeader';

export const orderStepForwardFormHeaderId = 'PayloadAddForm.orderStepForwardFormHeader';
const orderStepForwardFormHeaderOptions: RouteLocationModelSimpleTextDisplayOptions = {
    logisticUnitDisplayOptions: {
        hideContactButton: true,
    },
};
propsStore.insert(orderStepForwardFormHeaderOptions);

export const payloadFormGridId = 'PayloadAddForm.payloadGrid';
const payloadFormGridOptions: iDataGridDisplayOptions = {
    id: payloadFormGridId,
    columnAutoWidth: true,
    showBorders: false,
    width: '100%',
    height: '100%',
    editing: {
        allowDeleting: true,
        useIcons: false,
    },
    //
    columns: [
        {
            dataField: nameof<PayloadAddFormPayloadData>((c) => c.id),
            caption: '#',
            width: '50px',
            cellTemplate: 'RowIndexColumn',
        },
        {
            dataField: nameof<PayloadAddFormPayloadData>((c) => c.sku),
            caption: 't~Payload:column.sku',
            width: '30%',
        },
        {
            dataField: nameof<PayloadAddFormPayloadData>((c) => c.name),
            caption: 't~Payload:column.productName',
            width: '70%',
        },
        {
            dataField: nameof<PayloadAddFormPayloadData>((c) => c.productsQuantity),
            caption: 't~Payload:column.productsQuantity',
            width: '100px',
        },
        {
            dataField: nameof<PayloadAddFormPayloadData>((c) => c.requestedAmount),
            caption: 't~Payload:column.requestedAmount',
            width: '160px',
        },
        {
            dataField: nameof<PayloadAddFormPayloadData>((c) => c.carriersQuantity),
            headerCellTemplate: 'AllowedStacksHeader',
            cellTemplate: 'PayloadCarrierCountSimpleText',
            width: '120px',
        },
    ],
};
propsStore.insert(payloadFormGridOptions);

export const payloadAddFormProductToAddAllowedStacksHeaderId =
    'PayloadAddForm.payloadGrid.column.carriersQuantity';
const payloadAddFormProductToAddAllowedStacksHeaderOptions: AllowedStacksHeaderProps = {
    id: payloadAddFormProductToAddAllowedStacksHeaderId,
    title: 't~Payload:column.carriersQuantity',
};
propsStore.insert(payloadAddFormProductToAddAllowedStacksHeaderOptions);

export const payloadAddFormProductToAddSelectBoxId = 'PayloadAddForm.productToAddSelectBox';
const payloadAddFormProductToAddSelectBoxOptions: iLookupDisplayOptions = {
    id: payloadAddFormProductToAddSelectBoxId,
    width: '300px',
    displayExpr: (data: ProductToAddSelectBoxInfoData) =>
        [data?.sku, data?.name].filter(Boolean).join(', '),
    searchExpr: 'composite',
    dropDownOptions: {
        showTitle: false,
    },
};
propsStore.insert(payloadAddFormProductToAddSelectBoxOptions);

export const payloadAddFormProductWarehouseToAddSelectBoxId =
    'PayloadAddForm.payloadAddFormProductWarehouseToAddSelectBoxId';
const payloadAddFormProductWarehouseToAddSelectBoxOptions: iSelectBoxDisplayOptions = {
    id: payloadAddFormProductWarehouseToAddSelectBoxId,
    width: '300px',
    displayExpr: nameof<LogisticUnitSimpleTextData>((c) => c.name),
    valueExpr: nameof<LogisticUnitSimpleTextData>((c) => c.id),
};
propsStore.insert(payloadAddFormProductWarehouseToAddSelectBoxOptions);

export const payloadAddFormProductToAddInfoFormId = 'PayloadAddForm.productToAddInfoForm';
const payloadAddFormProductToAddInfoFormOptions: iFormDisplayOptions = {
    id: payloadAddFormProductToAddInfoFormId,
    labelLocation: 'left',
    items: [
        {
            dataField: nameof<ProductToAddInfoFormData>((c) => c.name),
            label: {
                text: 't~PayloadAddFormProductToAddInfoForm:name',
            },
        },
        {
            dataField: nameof<ProductToAddInfoFormData>((c) => c.sku),
            label: {
                text: 't~PayloadAddFormProductToAddInfoForm:sku',
            },
        },
        {
            dataField: nameof<ProductToAddInfoFormData>((c) => c.totalAvailableProductUnitsSum),
            label: {
                text: 't~PayloadAddFormProductToAddInfoForm:totalAvailableProductUnitsSum',
            },
        },
    ],
};
propsStore.insert(payloadAddFormProductToAddInfoFormOptions);

export const payloadAddFormCountOfCarriersToGetId =
    'PayloadAddForm.payloadAddFormCountOfCarriersToGet';
const payloadAddFormCountOfCarriersToGetOptions: iNumberBoxDisplayOptions = {
    id: payloadAddFormCountOfCarriersToGetId,
    //
    showClearButton: true,
    showSpinButtons: true,
    defaultValue: 0,
    min: 0,
    width: '300px',
    step: 10,
};
propsStore.insert(payloadAddFormCountOfCarriersToGetOptions);

export const payloadAddFormAddButtonId = 'PayloadAddForm.payloadAddFormAddButton';
const payloadAddFormAddButtonOptions: iButtonDisplayOptions = {
    id: payloadAddFormAddButtonId,
    width: '200px',
    text: 't~PayloadAddForm:confirmAddProductButton',
    type: 'success',
    stylingMode: 'contained',
    useSubmitBehavior: true,
};
propsStore.insert(payloadAddFormAddButtonOptions);

export const payloadAddFormRemoveAllButtonId = 'PayloadAddForm.payloadAddFormRemoveAllButton';
const payloadAddFormRemoveAllButtonOptions: iButtonDisplayOptions = {
    id: payloadAddFormRemoveAllButtonId,
    //
    width: '200px',
    text: 't~PayloadAddForm:removeAllButton',
    type: 'danger',
    stylingMode: 'text',
};
propsStore.insert(payloadAddFormRemoveAllButtonOptions);

export const payloadAddFormDoneButtonId = 'PayloadAddForm.doneButton';
const doneButtonOptions: iButtonDisplayOptions = {
    id: payloadAddFormDoneButtonId,
    //
    width: '200px',
    text: 't~PayloadAddForm:doneButton',
    stylingMode: 'contained',
    type: 'success',
};
propsStore.insert(doneButtonOptions);

export const payloadAddFormCancelButtonId = 'PayloadAddForm.cancelButton';
const cancelButtonOptions: iButtonDisplayOptions = {
    id: payloadAddFormCancelButtonId,
    //
    width: '200px',
    text: 't~PayloadAddForm:cancelButton',
    stylingMode: 'outlined',
    type: 'normal',
    validationGroup: 'none',
};
propsStore.insert(cancelButtonOptions);

export const payloadAddFormOpenAdvancedButtonId = 'PayloadAddForm.payloadAddFormOpenAdvancedButton';
const payloadAddFormOpenAdvancedButtonOptions: iButtonDisplayOptions = {
    id: payloadAddFormOpenAdvancedButtonId,
    //
    text: 't~PayloadAddForm:openAdvancedButton',
    stylingMode: 'text',
    type: 'success',
};
propsStore.insert(payloadAddFormOpenAdvancedButtonOptions);

export const payloadAddFormProductsGridId = 'PayloadAddForm.productsGrid';
export const payloadAddFormProductsGridOptions: iDataGridDisplayOptions = {
    id: payloadAddFormProductsGridId,
    columnAutoWidth: true,
    showBorders: false,
    allowColumnReordering: true,
    allowColumnResizing: true,
    width: '100%',
    height: '100%',
    filterRow: {
        visible: true,
    },
    groupPanel: {
        visible: true,
    },
    grouping: {
        autoExpandAll: true,
    },
    columnChooser: {
        allowSearch: true,
        enabled: true,
        height: 500,
        width: 400,
    },
    columnFixing: {
        enabled: true,
    },
    selection: {
        showCheckBoxesMode: 'always',
        mode: 'multiple',
        allowSelectAll: false,
    },
    /*
    filterPanel: {
        visible: true,
    },
    stateStoring: {
        enabled: true,
        type: 'localStorage',
        storageKey: 'PayloadAddForm.ProductsGrid',
    },*/
    //

    columns: [
        {
            type: 'selection',
            cellTemplate: 'AdvancedCheckBoxCell',
            width: '36px',
        },
        {
            dataField: nameof<ProductCarrierItemData>((c) => c.productName),
            caption: 't~PayloadAddForm:productsGrid.productName',
        },
        {
            dataField: nameof<ProductCarrierItemData>((c) => c.productId),
            caption: 't~PayloadAddForm:productsGrid.productId',
        },
        {
            dataField: nameof<ProductCarrierItemData>((c) => c.id),
            caption: 't~PayloadAddForm:productsGrid.id',
        },
        {
            dataField: nameof<ProductCarrierItemData>((c) => c.carrierStatus),
            caption: 't~PayloadAddForm:productsGrid.carrierStatus',
            filterValue: 'Unreserved',
            lookup: {
                valueExpr: 'value',
                displayExpr: 'text',
                dataSource: [
                    {
                        text: 't~CarrierStatus:Unreserved',
                        value: 'Unreserved',
                    },
                    {
                        text: 't~CarrierStatus:Intransport',
                        value: 'Intransport',
                    },
                    {
                        text: 't~CarrierStatus:Prereservation',
                        value: 'Prereservation',
                    },
                    {
                        text: 't~CarrierStatus:Reservation',
                        value: 'Reservation',
                    },
                    {
                        text: 't~CarrierStatus:Loadingfinished',
                        value: 'Loadingfinished',
                    },
                    {
                        text: 't~CarrierStatus:Blocked',
                        value: 'Blocked',
                    },
                ],
            },
        },
        {
            dataField: nameof<ProductCarrierItemData>((c) => c.stockStatus),
            caption: 't~PayloadAddForm:productsGrid.stockStatus',
            filterValue: 'Unreserved',
            visible: false,
            lookup: {
                valueExpr: 'value',
                displayExpr: 'text',
                dataSource: [
                    {
                        text: 't~PayloadAddForm:Unreserved',
                        value: 'Unreserved',
                    },
                    {
                        text: 't~PayloadAddForm:Intransport',
                        value: 'Intransport',
                    },
                    {
                        text: 't~PayloadAddForm:Prereservation',
                        value: 'Prereservation',
                    },
                    {
                        text: 't~PayloadAddForm:Reservation',
                        value: 'Reservation',
                    },
                    {
                        text: 't~PayloadAddForm:Loadingfinished',
                        value: 'Loadingfinished',
                    },
                    {
                        text: 't~PayloadAddForm:Blocked',
                        value: 'Blocked',
                    },
                ],
            },
        },
        {
            dataField: nameof<ProductCarrierItemData>((c) => c.stockAttributes!.attribute1!.value),
            caption: 't~PayloadAddForm:productsGrid.Partia_IZ10',
        },
        {
            dataField: nameof<ProductCarrierItemData>((c) => c.stockAttributes!.attribute5!.value),
            caption: 't~PayloadAddForm:productsGrid.DataProd_IZ11',
        },
        {
            dataField: nameof<ProductCarrierItemData>((c) => c.stockAttributes!.attribute4!.value),
            caption: 't~PayloadAddForm:productsGrid.NajlDo_IZ17',
            visible: false,
        },
        /////
        {
            dataField: nameof<ProductCarrierItemData>((c) => c.carrierStatusDescription),
            caption: 't~PayloadAddForm:productsGrid.carrierStatusDescription',
            visible: false,
        },
        {
            dataField: nameof<ProductCarrierItemData>((c) => c.isStackable),
            caption: 't~PayloadAddForm:productsGrid.isStackable',
            visible: false,
        },
        {
            dataField: nameof<ProductCarrierItemData>((c) => c.layersCount),
            caption: 't~PayloadAddForm:productsGrid.layersCount',
            visible: false,
        },
        {
            dataField: nameof<ProductCarrierItemData>((c) => c.stockStatusDescription),
            caption: 't~PayloadAddForm:productsGrid.stockStatusDescription',
            visible: false,
        },
        {
            dataField: nameof<ProductCarrierItemData>((c) => c.supplierName),
            caption: 't~PayloadAddForm:productsGrid.supplierName',
            visible: false,
        },
        {
            dataField: nameof<ProductCarrierItemData>(
                (c) => c.carrierWarehouseStorageData!.warehouseEntryDateTime
            ),
            caption:
                't~PayloadAddForm:productsGrid.carrierWarehouseStorageData.warehouseEntryDateTime',
            visible: false,
        },
        {
            dataField: nameof<ProductCarrierItemData>(
                (c) => c.carrierWarehouseStorageData!.warehouseEntryDocumentId
            ),
            caption:
                't~PayloadAddForm:productsGrid.carrierWarehouseStorageData.warehouseEntryDocumentId',
            visible: false,
        },
        // customowe fieldy :
        {
            dataField: nameof<ProductCarrierItemData>((c) => c.productUnitsOnCarrier),
            caption: 't~PayloadAddForm:productsGrid.productUnitsOnCarrier',
            visible: true,
        },
        {
            dataField: nameof<ProductCarrierItemData>((c) => c.stockAttributes!.attribute3!.value),
            visible: false,
        },
        {
            dataField: nameof<ProductCarrierItemData>((c) => c.stockAttributes!.attribute6!.value),
            caption: 't~PayloadAddForm:productsGrid.NajlDo_IZ17',
            visible: true,
        },
        {
            dataField: nameof<ProductCarrierItemData>((c) => c.stockAttributes!.attribute2!.value),
            caption: 't~PayloadAddForm:productsGrid.NajlepszeDo_IZ15',
            visible: true,
        },
        {
            dataField: nameof<ProductCarrierItemData>((c) => c.stockAttributes!.attribute7!.value),
            visible: false,
        },
        {
            dataField: nameof<ProductCarrierItemData>((c) => c.stockAttributes!.attribute8!.value),
            visible: false,
        },
        {
            dataField: nameof<ProductCarrierItemData>((c) => c.stockAttributes!.attribute9!.value),
            visible: false,
        },
        {
            dataField: nameof<ProductCarrierItemData>((c) => c.stockAttributes!.attribute0!.value),
            visible: false,
        },
    ],
};
propsStore.insert(payloadAddFormProductsGridOptions);

export const payloadAddFormAdvancedCancelButtonId =
    'PayloadAddForm.payloadAddFormAdvancedCancelButton';
const payloadAddFormAdvancedCancelButtonOptions: iButtonDisplayOptions = {
    id: payloadAddFormAdvancedCancelButtonId,
    //
    width: '200px',
    text: 't~PayloadAddForm:advanced.cancelButton',
    stylingMode: 'text',
    type: 'success',
};
propsStore.insert(payloadAddFormAdvancedCancelButtonOptions);

export const payloadAddFormAdvancedApplyButtonId =
    'PayloadAddForm.payloadAddFormAdvancedApplyButton';
const payloadAddFormAdvancedApplyButtonOptions: iButtonDisplayOptions = {
    id: payloadAddFormAdvancedApplyButtonId,
    //
    width: '200px',
    text: 't~PayloadAddForm:advanced.doneButton',
    stylingMode: 'contained',
    type: 'success',
    // @ts-ignore
    disabled: 'v~disableAdvancedDoneButton',
};
propsStore.insert(payloadAddFormAdvancedApplyButtonOptions);

export const payloadAddFormAdvanceHeaderLayoutId =
    'PayloadAddForm.payloadAddFormAdvanceHeaderLayout';
export const payloadAddFormAdvanceLayoutId = 'PayloadAddForm.payloadAddFormAdvanceLayout';
const payloadAddFormAdvanceLayoutOptions: iLayoutControlDisplayOptions = {
    id: payloadAddFormAdvanceLayoutId,
    schema: {
        root: {
            template: 'Flex',
            templateProps: {
                height: '100%',
            } as FlexTemplateProps,
        },
        children: [
            {
                id: payloadAddFormAdvanceHeaderLayoutId,
                template: 'Flex',
                templateProps: {
                    height: '50px',
                } as FlexTemplateProps,
            },
            {
                template: 'Flex',
                templateProps: {
                    height: '60px',
                } as FlexTemplateProps,
                children: [
                    {
                        id: payloadAddFormProductWarehouseToAddSelectBoxId,
                        template: 'FieldValueStatic',
                        templateProps: {
                            label: 't~PayloadAddForm:selectBoxStockName',
                        },
                    },
                ],
            },
            {
                id: payloadAddFormProductsGridId,
                template: 'Flex',
                templateProps: {
                    flex: 'auto',
                } as FlexTemplateProps,
            },
            {
                template: 'BottomButtons',
                children: [
                    {
                        id: payloadAddFormAdvancedCancelButtonId,
                    },
                    {
                        id: payloadAddFormAdvancedApplyButtonId,
                    },
                ],
            },
        ],
    },
};
propsStore.insert(payloadAddFormAdvanceLayoutOptions);
